export const ROUTES = {
  HOME_PAGE: '/',
  RECIPE_DETAIL_PAGE: '/recipes/:recipeId',
}
